export default __webpack_public_path__ + "static/helles-logo_EN-19d4fb8e1f5cffe574124e70c32d69ec.svg";